export default __webpack_public_path__ + "static/media/Button Right.e4a51ab5.svg";